import { useState, useEffect } from "react"; // this you created
import Loader from ".";
import { setLoadingFunctions } from "config/loaderManager";

const LoaderManager = () => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setLoadingFunctions(
      () => {
        setProgress(0);
        setLoading(true);
      },
      () => {
        setProgress(100);
        setTimeout(() => {
          setLoading(false);
          setProgress(0);
        }, 300);
      }
    );
  }, []);

  useEffect(() => {
    let interval;
    if (loading && progress < 100) {
      interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 99) return prev;

          const remaining = 95 - prev;
          if (remaining <= 0) return 99;

          const randomFactor = Math.random() * 1.5 + 0.5;
          const increment = (remaining / 20) * randomFactor;

          return Math.min(prev + increment, 99);
        });
      }, 100);
    }
    return () => clearInterval(interval);
  }, [loading]);

  if (!loading) return null;

  return (
    <div
      style={{
        position: "fixed",
        zIndex: 99999999,
        backgroundColor: "rgba(255,255,255,0.7)",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader percentage={progress} />
    </div>
  );
};

export default LoaderManager;
